import React from 'react';

function Footer() {
  return (
    <footer className="footer">
              <div className="footer-container">
        <div className="address">
          <strong>Адрес:</strong>
          <p>121500, г. Москва, ул. Василия Ботылева, дом 6, офис 14</p>
        </div>
        <div className="phone">
          <strong>Телефон:</strong>
          <p>+7 977 495 5525</p>
        </div>
        <div className="email">
          <strong>E-mail:</strong>
          <p>beautyolymp@gmail.com </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
